<template>
  <div></div>
</template>

<script>
  // import NavHeader from '@/common-components/nav-header'
  import api from './api'
  export default {
    name: 'callback',
    data () {
      return {
      }
    },
    methods: {
      async doLogin () {
        let obj = {
          code: this.$route.query.code,
          state: this.$route.query.state
        }
        let res = await api.getApplication(obj)
        if (res.data.data.isRegister) {
          localStorage.setItem('token', res.data.data.accessToken)
          localStorage.setItem('avatar', res.data.data.headImgUrl)
          localStorage.setItem('userName', res.data.data.nickname)
          localStorage.setItem('unionId', res.data.data.unionId)
          this.$router.push({path: `/home`})
        } else {
          localStorage.setItem('unionId', res.data.data.unionId)
          this.$router.push({path: `/register`})
        }
      }
    },
    created () {
      this.doLogin()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/register/callback.vue